
import { ref, onMounted } from "vue";

export default {
  name: "EnterpriseForm",
  setup() {
    const scrollPosition = ref(0);
    function updateScroll() {
      scrollPosition.value = window.scrollY;
    }

    onMounted(() => {
      window.addEventListener("scroll", updateScroll);
    });

    return {
      scrollPosition,
      updateScroll,
    };
  },
};
